import React, { useEffect, useState } from "react";

export function Pagination({ items = [], itemsPerPage = 10 }) {
  const [pagination, setPagination] = useState({
    page: 1,
    items: [],
    pages: 1,
    start: 0,
    stop: 1,
  });

  useEffect(() => {
    const totalPages = Math.ceil(items.length / itemsPerPage);
    const start = 0;
    const end = Math.min(itemsPerPage - 1, items.length - 1);

    setPagination({
      page: 1,
      items: items.slice(start, end + 1),
      pages: totalPages,
      start: start,
      end: end,
    });
  }, [items]);

  function updatePagination(current) {
    lastPrintedRev = null;
    if (!items || items.length < 1) return;
    const totalPages = Math.ceil(items.length / itemsPerPage);
    const start = (current - 1) * itemsPerPage;
    const end = Math.min(start + itemsPerPage - 1, items.length - 1);

    setPagination({
      page: current,
      items: items.slice(start, end + 1),
      pages: totalPages,
      start: start,
      end: end,
    });
  }

  let lastPrintedRev = null;

  function RevisionPagination() {
    const numOfPagesToShow = 5; // Update this to show more or less page buttons

    if (pagination.items.length < 1) return null;
    if (pagination.items.pages < 2) return null;

    let buttons = [];
    for (let i = 1; i <= pagination.pages; i++) {
      buttons.push({
        label: i,
        ellipsis: false,
      });
    }

    // Generate a subset of buttons to show
    let start = Math.max(pagination.page - Math.floor(numOfPagesToShow / 2), 1); // Ensuring that we start from at least the 1st page
    let end = Math.min(start + numOfPagesToShow, buttons.length + 1); // Plus 1 because slice's end index is not inclusive
    if (end - start < numOfPagesToShow) {
      start = Math.max(end - numOfPagesToShow, 1); // Ensuring that we start from at least the 1st page
    }
    const subset = buttons.slice(start - 1, end - 1); // Minus 1 because array indices start from 0

    // Insert ellipsis at start and end if necessary
    if (start > 1) {
      // Updated condition to ensure ellipsis is never the first item
      subset.unshift({ label: 1, ellipsis: false });
      subset.splice(1, 0, { label: "...", ellipsis: true });
    }
    if (end <= buttons.length) {
      subset.push({ label: "...", ellipsis: true });
      subset.push({ label: buttons.length, ellipsis: false });
    }

    return (
      <div>
        <div>{pagination.items.map((child) => child || null)}</div>

        <div className="flex flex-row justify-center">
          {pagination.pages > 1 && (
            <button
              key="previous"
              onClick={() => updatePagination(pagination.page - 1)}
              className={`px-3 py-2 text-blue hover:underline disabled:cursor-default disabled:opacity-50 disabled:hover:no-underline`}
              disabled={pagination.page < 2}
            >
              Previous
            </button>
          )}
          {subset.length > 1 &&
            subset.map((b, ii) => (
              <button
                key={ii}
                onClick={() => !b.ellipsis && updatePagination(b.label)}
                className={`mx-1 rounded-sm px-3 py-2 hover:bg-primary-light ${b.label == pagination.page ? "bg-primary text-white" : ""}`}
                disabled={b.ellipsis}
              >
                {b.label}
              </button>
            ))}
          {pagination.pages > 1 && (
            <button
              key="next"
              onClick={() => updatePagination(pagination.page + 1)}
              className={`px-3 py-2 text-blue hover:underline disabled:cursor-default disabled:opacity-50 disabled:hover:no-underline`}
              disabled={pagination.page >= pagination.pages}
            >
              Next
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="mt-4 flex flex-col pb-4">
      <RevisionPagination />
    </div>
  );
}
